import styled from '@emotion/styled';

export const CalenderButtonWrap = styled.button<{ active?: boolean }>`
  width: 42px;
  height: 51px;
  border-radius: 4px;
  border: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;
  background: ${props =>
    props.active
      ? 'linear-gradient(136.67deg, #FFC9C9 0%, #F4C9FF 52.41%, #B5E8FF 100%)'
      : 'transparent'};
`;
